import React, { useRef, useCallback, useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { updateDato } from '../funzioni';

function UploadFile(props) {
  const { descrizione, modificabile, idDato, attach } = props;
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const fileInputRef = useRef(null);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleFileSubmission = useCallback(async () => {
    if (!fileInputRef.current) return;

    const file = fileInputRef.current.files[0];

    if (!file) {
      alert('Please, select a file to upload');
      return;
    }

    const result = await toBase64(file).catch((e) => Error(e));

    if (result instanceof Error) {
      alert('errore nel caricare il file');
      console.error(result);
      return;
    }

    updateDato(
      () => {
        setIsButtonLoading(true);
      },
      () => {
        setIsButtonLoading(false);
        alert('File uploaded successfully');
      },
      () => {
        setIsButtonLoading(false);
      },
      idDato,
      result,
      'file'
    );
  }, [fileInputRef]);

  return (
    <>
      <Card border className="border-primary h-100">
        <Card.Header className="p-3 h-100 d-flex flex-column align-items-center justify-content-center">
          <Card.Title className="m-0">{descrizione}</Card.Title>
          <br />
          {attach && (
            <a href={attach} target="_blank" rel="noreferrer">
              Download guidelines
            </a>
          )}
        </Card.Header>
        <Card.Body className="d-flex flex-column justify-content-end" style={{ height: 100 }}>
          <div className="d-flex justify-content-between align-items-end">
            <Form.Group controlId="formFile" className="w-100 me-4">
              <Form.Control type="file" accept="application/pdf" ref={fileInputRef} disabled={!modificabile} />
            </Form.Group>
            <Button onClick={handleFileSubmission} disabled={!modificabile}>
              Upload
            </Button>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default UploadFile;
